import { render } from "./icon_send-message.svg?vue&type=template&id=5a0ce35c"
const script = {}

import exportComponent from "/var/www/briskly/brskl/products/business/app.prod.new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__